import { render } from "./MedicalCertificate.vue?vue&type=template&id=5ddc1dfe&scoped=true"
import script from "./MedicalCertificate.vue?vue&type=script&lang=js"
export * from "./MedicalCertificate.vue?vue&type=script&lang=js"

import "./MedicalCertificate.vue?vue&type=style&index=0&id=5ddc1dfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddc1dfe"]])

export default __exports__